var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _vm.changeLogFeatureFlag
    ? _c(
        "div",
        [
          _vm.showChangeLog
            ? _c(
                "popover",
                {
                  directives: [
                    {
                      name: "click-outside",
                      rawName: "v-click-outside",
                      value: { binding: _vm.togglePopover, focus: ".popover" },
                      expression: "{binding: togglePopover, focus: '.popover'}"
                    }
                  ],
                  class: "breakdown-legend__popover",
                  attrs: {
                    target: `#popover-${_vm.objectId}`,
                    placement: "left",
                    trigger: "manual"
                  },
                  model: {
                    value: _vm.showChangeLog,
                    callback: function($$v) {
                      _vm.showChangeLog = $$v
                    },
                    expression: "showChangeLog"
                  }
                },
                [
                  _c(
                    "template",
                    { slot: "popover" },
                    [
                      _c("h2", { staticClass: "m-b-10 in-app-header" }, [
                        _vm._v(
                          "\n        " +
                            _vm._s(_vm.$t("TITLE_ACTIVITY_FEED")) +
                            " " +
                            _vm._s(_vm.objectType) +
                            ":\n        "
                        ),
                        _c("strong", {
                          domProps: { textContent: _vm._s(_vm.objectName) }
                        })
                      ]),
                      _vm._v(" "),
                      _c(
                        "a",
                        {
                          staticClass: "close in-app-popover__btn-close",
                          on: { click: _vm.togglePopover }
                        },
                        [_c("i", { staticClass: "typcn typcn-delete" })]
                      ),
                      _vm._v(" "),
                      _vm.showChangeLog
                        ? _c("ChangeLog", {
                            attrs: {
                              "custom-class": "changelogs--md",
                              "object-id": _vm.objectId,
                              "show-non-primary-actions":
                                _vm.showNonPrimaryActions
                            }
                          })
                        : _vm._e()
                    ],
                    1
                  )
                ],
                2
              )
            : _vm._e(),
          _vm._v(" "),
          _c("div", { staticClass: "action-icon" }, [
            _c(
              "a",
              {
                staticClass: "m-t-4 btn btn-list-function",
                attrs: {
                  id: `popover-${_vm.objectId}`,
                  disabled: _vm.isDisabled
                },
                on: { click: _vm.togglePopover }
              },
              [
                _c("i", {
                  directives: [
                    {
                      name: "tooltip",
                      rawName: "v-tooltip.right.hover",
                      value: _vm.$t("VIEW_ACTIVITY_TEXT"),
                      expression: "$t('VIEW_ACTIVITY_TEXT')",
                      modifiers: { right: true, hover: true }
                    }
                  ],
                  staticClass: "fa fa-history",
                  attrs: { "aria-hidden": "true" }
                }),
                _vm._v(" "),
                _c("span", {
                  directives: [
                    {
                      name: "t",
                      rawName: "v-t",
                      value: "VIEW_ACTIVITY_TEXT",
                      expression: "'VIEW_ACTIVITY_TEXT'"
                    }
                  ],
                  staticClass: "hint-text-mobile"
                })
              ]
            )
          ])
        ],
        1
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }